import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2a8a8a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row items-center" }
const _hoisted_2 = { class: "pt-2" }
const _hoisted_3 = { class: "text-gray-text ms-auto" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = { class: "text-sm text-white uppercase" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-text mb-3" }, "Use this wallet address for sending and receiving tokens.", -1))
const _hoisted_7 = { class: "flex flex-row items-center mt-5" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  for: "wallet-address",
  class: "text-white text-sm w-28 mr-2"
}, "Wallet Address", -1))
const _hoisted_9 = {
  key: 0,
  class: "flex items-center w-full sm:w-60 lg:w-100"
}
const _hoisted_10 = ["copyValue"]
const _hoisted_11 = {
  key: 1,
  class: "flex items-center w-full sm:w-60 lg:w-100"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white inline-block" }, "This account is not connected to any wallet address", -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, "Username: " + _toDisplayString(_ctx.username), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.label) + " Wallet Address", 1),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        (_ctx.walletAddress)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "text-white inline-block",
                id: "walletAddress",
                copyValue: _ctx.walletAddress
              }, _toDisplayString(_ctx.walletAddress), 9, _hoisted_10),
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-copy",
                class: "inline-block",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copy('walletAddress')))
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
      ])
    ])
  ]))
}